import React, { Component } from "react"
import BookingStarter from "./bookingStarter"
import { isMobile } from "react-device-detect"
import SimpleErrorModal from "../../shared/modal/simple-error-modal"

class BookingHero extends Component {
  static defaultProps = {
    modifier_class: "hero--parking",
    imageUrl: "/static/photos/mock-hero.jpg",
    videoUrl: "",
    headlineImageUrl: null,
    label: "Parkering & Transport",
    headline: "Parkering fra kun <span class='t--highlight'>360,-</span> pr. uge",
    videoType: "video/mp4",
  }

  constructor(props) {
    super(props)

    this.state = {
      modalOpen: false,
      modalData: { h3: "", richText: "" },
    }
  }

  openModal = () => {
    const data = {
      modalOpen: true,
      modalData: {
        h3: this.props.refundGuaranteeModalHeadline,
        richText: this.props.refundGuaranteeModalText,
      },
    }
    this.setState(data)
  }

  handleModalClose = () => {
    this.setState({ modalOpen: false })
  }

  render() {
    const {
      modifier_class,
      imageUrl,
      headlineImageUrl,
      label,
      headline,
      videoUrl,
      videoType,
      button,
      textKeys,
      refundGuaranteeText,
      refundGuaranteeImage,
      refundGuaranteeLinkText,
    } = this.props
    return (
      <section className="deck deck--top deck--front">
        <div className={`hero ${modifier_class}`}>
          {headlineImageUrl ? (
            <span className="hero__image hero__image--headline">
              <img src={headlineImageUrl} />
            </span>
          ) : (
            ""
          )}
          {videoUrl ? (
            <span>
              {!isMobile ? (
                <span className="hero__video">
                  {/* eslint-disable react/no-unknown-property */}
                  <video autoPlay loop={true} muted preload={"auto"} loading="eager" fetchpriority="high">
                    {/* eslint-enable react/no-unknown-property */}
                    {/* don't show video on IOS as it will focus and play in full screen on 'ryd parkering' link activation */}
                    <source src={videoUrl} type={videoType} />

                    {imageUrl ? (
                      <img src={imageUrl} />
                    ) : (
                      // <span className={"hero__image"} style={{ backgroundImage: `url(${imageUrl})` }}>
                      // </span>
                      ""
                    )}
                  </video>
                </span>
              ) : (
                <span className="hero__image"></span>
              )}
            </span>
          ) : (
            ""
          )}

          <div className={"hero__content hero__content__parking"}>
            {label ? <h6 dangerouslySetInnerHTML={{ __html: label }}></h6> : ""}
            <h1 dangerouslySetInnerHTML={{ __html: headline }}></h1>
            {refundGuaranteeText ? (
              <div className="refund-guarantee refund-guarantee--hero">
                {refundGuaranteeImage ? <img className="refund-image" src={refundGuaranteeImage} /> : ""}
                <span className="refund-text" dangerouslySetInnerHTML={{ __html: refundGuaranteeText }}></span>
                {refundGuaranteeLinkText ? (
                  <a className="modal-link" onClick={() => this.openModal()}>
                    {refundGuaranteeLinkText}
                  </a>
                ) : (
                  ""
                )}
              </div>
            ) : (
              ""
            )}
            <BookingStarter
              {...this.props}
              disclaimer={true}
              noPrefill={true}
              noHeader={true}
              slimVersion={true}
              noWidth={true}
              buttonClasses={" button--large button--general-inverted "}
              wide={false}
              flow={false}
              // modifiers={"parking-time-picker--blue parking-time-picker--flow"}
              campaignCode={false}
              formClasses={null}
              replaceHistory={false}
              searchOnBlur={false}
              button={button}
              textKeys={textKeys}
            />
            {this.state.modalOpen ? <SimpleErrorModal errorData={this.state.modalData} modalOpen={true} closeHandler={this.handleModalClose} /> : ""}
          </div>
        </div>
      </section>
    )
  }
}

export default BookingHero
